import {
  ModalIconAiHelp,
  ModalIconWonderblocks,
  ModalIconWordpress,
} from '~/scenes/Hosting/scenes/HostingDetail/components/FirstSiteInstalling/assets';
import { getBrandLogo } from '~/utils/brand/helpers';

export const getSiteInstallingSlides = (brand: string) => [
  {
    heading: 'Your new WordPress site is installing!',
    body: `While we work our magic, take a quick peek at some amazing new features we've brought to WordPress.`,
    image: ModalIconWordpress,
  },
  {
    heading: 'Unleashing the Power of AI',
    body: 'No more scanning for answers. Our new AI-powered Help Center provides a highly personalized and seamless support experience inside of WordPress.',
    image: ModalIconAiHelp,
  },
  {
    heading: `Your ${brand} account is always with you`,
    body: `We've introduced effortless switching between managing your ${brand} account and WordPress site.`,
    image: getBrandLogo(brand)?.icon,
  },
  {
    heading: 'Building is a snap with WonderBlocks!',
    body: `The WonderBlocks builder tool allows you to select from a library of pre-made layouts.  It's as easy as drag, drop and save.`,
    image: ModalIconWonderblocks,
  },
];
